/**
 * "Skip for now" on the quick-unlock PIN prompt.
 *
 * PIN setup is optional, but /auth/me reports pin.set=false on every load, so
 * without a remembered skip the prompt re-appears on each refresh (and used to
 * loop forever because "Skip" reloaded straight back into it). The skip lasts
 * for the browser session and is keyed by user id so a different account on
 * the same tab is still prompted.
 */

const KEY_PREFIX = 'hyperion.pinSetup.skipped.';

export function rememberPinSkip(userId: string | null | undefined): void {
  if (!userId) return;
  try {
    sessionStorage.setItem(KEY_PREFIX + userId, '1');
  } catch {
    /* storage unavailable — the in-memory clear still applies this load */
  }
}

export function hasSkippedPin(userId: string | null | undefined): boolean {
  if (!userId) return false;
  try {
    return sessionStorage.getItem(KEY_PREFIX + userId) === '1';
  } catch {
    return false;
  }
}
